import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('XboxIntegrationNews').create(() => ({
  root: {
    width: '90%',
    height: '120px',
    backgroundSize: '100%',
    backgroundPosition: 'center',
    borderRadius: '12px',
  },
}))
